import { getToken } from "../../utils/auth";
import { dev_baseUrl } from "../../utils/var";

export const DownloadAttachments = async (MediaType, EntityType, EntityId, fileName, navigate) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Media/download/${MediaType}/${EntityType}/${EntityId}/${fileName}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
        },
      });

      if (response.status === 401) { // Handle unauthorized case
        navigate(`/login`);
        return null;
      }

      if (!response.ok) {
        console.error(`Error: ${response.status} - ${response.statusText}`);
        return { form: 'Failed to download the file. Please try again later.' };
      }

      const blob = await response.blob(); // Parse response as binary data
      return blob;

    } catch (error) {
      console.error('Network error:', error);
      return { form: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
